var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"60px","width":"100%"},attrs:{"id":"weather-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }